module.exports = __webpack_public_path__ + "static/media/hikari.f93e6142.gif";